<template>
    <div>
        <up-low-paging @pageChange="pageChange" :pagingInfo="pagingInfo" :hide-paging="hidePaging" :ignore-watch-route="true">
            <Loading :show="isLoading"></Loading>
            <div>
                <div v-if="items!==null && items.length===0 && !hideNoData">
                    <div class="alert alert-warning" role="alert" style="text-align:center;">
                        <span>{{lang.common.noData}}</span>
                    </div>
                </div>

                <template v-if="cardViewName!==null">
                    <template v-if="cardView==='banner' || cardView==='bigBanner'">
                        <div v-for="(item,index) in items">
                            <banner-card v-if="cardView==='banner'" :item="item" :style-mode="index%2" :detail-page="initFilter.catSubType===0?'detail':'articleDetail'"></banner-card>
                            <big-banner-card v-else-if="cardView==='bigBanner'" :item="item" :style-mode="index%2" :detail-page="initFilter.catSubType===0?'detail':'articleDetail'"></big-banner-card>
                        </div>
                    </template>
                    <template v-else>
                        <div v-for="(item,index) in items">
                            <component :is="cardViewName" :item="item"></component>
                        </div>
                    </template>
                </template>
            </div>
        </up-low-paging>
    </div>
</template>
<script>
    import UpLowPaging from './base/UpLowPaging.vue';
    import Loading from './base/LoadingRelative.vue';
    import SaleCard from './cards/sale.vue';
    import InfoCard from './cards/info.vue';
    import InfoTextCard from './cards/infotext.vue';
    import BannerCard from './cards/banner.vue';
    import BigBannerCard from './cards/bigBanner.vue';
    import LinkCard from './cards/link.vue';
    import MediaCard from './cards/media.vue';
    import MediaStackCard from './cards/mediaStack.vue';
    import TextCard from './cards/text.vue';
    import DualCard from './cards/dual.vue';
    import QueryHelper from '../utl/queryString';

    var _cardsMap = {
        sale: "SaleCard",
        info: "InfoCard",
        infoText:"InfoTextCard",
        text: "TextCard",
        link: "LinkCard",
        dual: "DualCard",
        media:"MediaCard",
        mediaStack:"MediaStackCard"
    };

    export default {
        props: {
            "filterInfo": Object,
            "initFilter": Object,
            "hideNoData": { type: Boolean, default: true }
        },
        components: {
            TextCard: TextCard,
            SaleCard: SaleCard,
            InfoCard: InfoCard,
            InfoTextCard: InfoTextCard,
            BannerCard: BannerCard,
            BigBannerCard: BigBannerCard,
            LinkCard: LinkCard,
            MediaCard: MediaCard,
            MediaStackCard: MediaStackCard,
            DualCard: DualCard,
            UpLowPaging: UpLowPaging,
            Loading: Loading
        },
        computed: {
            lang: function () {
                return this.$store.getters.lang;
            },
            apiClient: function () {
                return this.mxnAgxApi.pagedInfosApiClient;
            },
            currency: function () {
                return this.$store.getters.configs.currency;
            },
            filterCats: function () {
                if (!this.filterInfo) return [];
                if (this.filterInfo === null || this.filter == null) return [];
                return this.getMatchedCatPair(this.filterInfo.listingCats, this.filter.cats);
            },
            filterTags: function () {
                if (!this.filterInfo) return [];
                if (this.filterInfo === null || this.filter == null) return [];
                return this.getMatchedCatPair(this.filterInfo.itemTagCats, this.filter.tags);
            },
            parentId: function () {
                if (this.initFilter !== null && this.initFilter.prid !== null) {
                    return this.initFilter.prid;
                }
            },
            cardViewName: function () {
                if (this.cardView === null) return null;
                return _cardsMap[this.cardView];
            }
        },
        methods: {
            getMatchedCatPair: function (poolArr, idsArr) {
                var catGroups = poolArr;
                var cats = idsArr;
                var retPairs = [];
                for (var i = 0; i < cats.length; i++) {
                    var catId = cats[i];
                    for (var g = 0; g < catGroups.length; g++) {
                        var grp = catGroups[g];
                        var subs = grp.childs;
                        for (var s = 0; s < subs.length; s++) {
                            var sCat = subs[s];
                            if (sCat.catId === catId) {
                                retPairs.push({ parent: grp.parent, cat: sCat });
                            }
                        }
                    }
                }
                return retPairs;
            },
            getRoutePage: function () {
                var rPage = this.$route.query.page;
                if (typeof rPage === "undefined") {
                    rPage = 1;
                };
                return rPage;
            },
            pageChange: function (page) {
                this.filterObj.page = page;
                this.loadItems(this.getQueryString());
            },
            textChange: function (page, totalPage) {
                this.page = page;
                this.totalPage = totalPage;
            },
            loadItems: function (queryString) {
                this.isLoading = true;
                this.items = null;
                this.apiClient.getItemsPrms(queryString).done((data) => {
                    this.isLoading = false;
                    var filter = data.filter;
                    this.filter = filter;
                    this.pagingInfo = { page: filter.page, pageSize: filter.pageSize, count: filter.count };
                    this.items = data.posts;
                    this.loadedQuery = queryString;
                });
            },
            getQueryString: function () {
                var qs = QueryHelper().getString(this.filterObj);
                console.log('getQueryString', qs);
                return qs;
            },
            initPaging: function () {
                var obj = {
                    page: this.initFilter.page || 1,
                    pageSize: this.initFilter.pageSize,
                    cat: this.initFilter.cats,
                    tag: this.initFilter.tags,
                    prid: this.parentId,
                    catSubType: this.initFilter.catSubType,
                    getLinks: this.initFilter.getLinks
                };
                this.filterObj = obj;
                this.loadItems(this.getQueryString());
            }
        },
        data: function () {
            return {
                items: null,
                page: 1,
                totalPage: 1,
                pagingInfo: { page: 1, pageSize: 1, count: 1 },
                hidePaging: this.initFilter.hidePaging,
                cardView: this.initFilter.cardView,
                filter: null,
                filterObj: null,
                isLoading: false,
                loadedQuery: null,
                timeStamp: new Date().toLocaleString()
            }
        },
        //watch: {
        //    '$route'(to, from) {
        //        console.log("route change fired:" + this.timeStamp);
        //        if (to.name === 'listing') {
        //            this.page = this.getRoutePage();
        //            var qstr = this.getQueryString();
        //            console.log('loadedQuery:', this.loadedQuery,',current query:', qstr,',', this.loadedQuery === qstr);
        //            if (qstr === this.loadedQuery) {
        //                return;
        //            }
        //            this.loadItems(qstr);
        //        }
        //    }
        //},
        mounted: function () {
            this.initPaging();
        },
        activated: function () {
            console.log('activated');
        },
        deactivated: function () {
            console.log('deactivated');
        }
    }
</script>